import { AlertDialog, Button, Flex, Text } from '@radix-ui/themes'
import { UnschedulePreviewResponse } from '@Generated/back-office-client/src'

export const UnscheduleConfirmation = ({
  preview,
  onConfirm,
  onCancel,
  error,
  isSubmitting,
}: {
  preview: UnschedulePreviewResponse
  onConfirm: () => void
  onCancel: () => void
  error?: string | null
  isSubmitting?: boolean
}) => {
  const reassignCount = preview.reassignableReservations.length
  const cancelCount = preview.cancellableReservations.length
  const hasImpact = reassignCount > 0 || cancelCount > 0

  return (
    <AlertDialog.Root open={true}>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>Remove Appointment Slot?</AlertDialog.Title>
        <AlertDialog.Description size="2">
          <Flex direction="column" gap="2">
            {hasImpact ? (
              <>
                {reassignCount > 0 ? (
                  <Text>
                    {reassignCount} reservation{reassignCount !== 1 ? 's' : ''} will be reassigned
                    to other available slots.
                  </Text>
                ) : null}
                {cancelCount > 0 ? (
                  <Text color="red">
                    {cancelCount} reservation{cancelCount !== 1 ? 's' : ''} will be cancelled
                    because there are no other slots available at their scheduled time.
                  </Text>
                ) : null}
              </>
            ) : (
              <Text>No reservations are affected by this change.</Text>
            )}
          </Flex>
        </AlertDialog.Description>
        {error ? (
          <Text size="2" color="red" mt="2">
            {error}
          </Text>
        ) : null}
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray" onClick={onCancel}>
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button
              variant="solid"
              color="red"
              onClick={onConfirm}
              disabled={isSubmitting}
              loading={isSubmitting}>
              Remove Slot
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
